import { render, staticRenderFns } from "./RemainingRounds.vue?vue&type=template&id=d1620814&"
import script from "./RemainingRounds.vue?vue&type=script&lang=js&"
export * from "./RemainingRounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports